import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FormattedMessage, injectIntl } from "react-intl";
import { Button, WhiteSpace } from "antd-mobile";
import TextInput from "../../components/TextInput";
import LoadingIndicator from "../../components/LoadingIndicator";
import _ from "underscore";
import Theme from "../../utils/Theme";
import "./index.css";
import * as commonAction from "../../actions/common";
import * as profileAction from "../../actions/profile";
import * as selectors from "../../selectors";

const StyledContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  text-align: left;
  color: grey;
  background: #fff;
  height: 100%;
`;

const StyledContent = styled.div`
  padding: 0.5em 1.4em;
`;

const StyledButton = styled(Button)`
  && {
    cursor: pointer;
    font-size: 1em
    border-radius: 25px;
    color: white;
    background-color: ${Theme.PrimaryColor};
  }
`;

class ProfileDetailsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animationClass: null,
      occupation: null,
      ic_number: "",
      name: "",
      email: "",
      other: {
        value: "",
        error: false,
        error_message: ""
      },
      selectedOption: null
    };
  }

  componentDidMount() {
    const {
      navbarConfig,
      showTabbar,
      showNavbar,
      getProfileDetails
    } = this.props;

    navbarConfig(
      <FormattedMessage
        id="profile.details.title"
        defaultMessage="Profile Details"
        description="Profile Details"
      />,
      null,
      null,
      () => this.onBackPressed(),
      null
    );
    showNavbar(true);
    showTabbar(false);
    this.setDefaultValue(getProfileDetails);
    this.fetchOccupation();
    this.setState({ animationClass: "slide-in-right" });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { getProfileDetails } = this.props;
    if (nextProps.getProfileDetails !== getProfileDetails) {
      if (!_.isEmpty(nextProps.getProfileDetails)) {
        this.setDefaultValue(nextProps.getProfileDetails);
      }
    }
  }

  fetchOccupation = () => {
    const { getOccupation } = this.props;
    getOccupation && getOccupation();
  };

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  validateFields = () => {
    const { other } = this.state;

    if (_.isEmpty(other.value.trim())) {
      other.error = true;
      other.error_message = "Cannot Be Empty";
    } else {
      other.error = false;
      other.error_message = "";
    }

    this.setState({ other: other });
  };

  onSubmit = () => {
    const { occupation, other } = this.state;
    const { updateProfileBasic } = this.props;
    if (occupation === 999) {
      this.validateFields();
      if (!other.error) {
        updateProfileBasic(this.getProfileDetailsOtherData());
      }
    } else {
      updateProfileBasic(this.getProfileDetailsData());
    }
  };

  setDefaultValue = ProfileDetails => {
    const name =
      ProfileDetails && ProfileDetails.display_name
        ? ProfileDetails.display_name
        : null;
    const nric =
      ProfileDetails && ProfileDetails.nric ? ProfileDetails.nric : null;
    const email =
      ProfileDetails && ProfileDetails.email ? ProfileDetails.email : null;
    const occupation_id =
      ProfileDetails && ProfileDetails.occupation_id
        ? ProfileDetails.occupation_id
        : null;
    const occupation_name =
      ProfileDetails && ProfileDetails.occupation
        ? ProfileDetails.occupation
        : null;

    this.setState({ name: name });
    this.setState({ ic_number: nric });
    this.setState({ email: email });
    if (occupation_id !== null) {
      this.setState({ occupation: occupation_id });
      this.setState({
        selectedOption: [{ value: occupation_id, label: occupation_name }]
      });
    } else {
      this.setState({ occupation: 999 });
      this.setState({ selectedOption: [{ value: 999, label: "Other" }] });
      this.setState({
        other: {
          value: occupation_name,
          error: false,
          error_message: ""
        }
      });
    }
  };

  onICNumberChange = txt => {
    this.setState({
      ic_number: txt
    });
  };

  onNameChange = txt => {
    this.setState({
      name: txt
    });
  };

  onEmailChange = txt => {
    this.setState({
      email: txt
    });
  };

  onOtherChange = txt => {
    this.setState({
      other: {
        value: txt,
        error: false,
        error_message: ""
      }
    });
  };

  getProfileDetailsOtherData = () => {
    const { ic_number, name, email, other } = this.state;

    return {
      display_name: name,
      nric: ic_number,
      email: email,
      occupation_id: null,
      occupation: other.value
    };
  };

  getProfileDetailsData = () => {
    const { ic_number, name, email, occupation, other } = this.state;

    return {
      display_name: name,
      nric: ic_number,
      email: email,
      occupation_id: occupation,
      occupation: other.value
    };
  };

  handleChange = selectedOption => {
    this.setState({ selectedOption });
    if (selectedOption.value !== 999) {
      this.setState({ occupation: selectedOption.value });
      this.setState({ other: { value: selectedOption.label } });
    } else {
      this.setState({ occupation: selectedOption.value });
      this.setState({ other: "" });
    }
  };

  render() {
    const {
      name,
      ic_number,
      email,
      other,
      selectedOption,
      occupation
    } = this.state;
    const { OccupationData, profileDetailsBasicLoading } = this.props;

    let occupationList = [];
    !_.isEmpty(OccupationData)
      ? OccupationData.map(occupations =>
          occupationList.push({
            value: occupations.id,
            label: occupations.name
          })
        )
      : null;
    occupationList.push({ value: 999, label: "Other" });

    return (
      <StyledContainer>
        {profileDetailsBasicLoading ? <LoadingIndicator /> : null}
        <StyledContent>
          <FormattedMessage
            id="profile.details.ic"
            defaultMessage="IC No"
            description="IC Number"
          />
          <TextInput
            type={"default"}
            className={"icInput"}
            placeholder={"Please enter you ic number"}
            onChange={txt => this.onICNumberChange(txt)}
            value={ic_number}
          />

          <FormattedMessage
            id="profile.details.Name"
            defaultMessage="Name"
            description="Name"
          />
          <TextInput
            type={"default"}
            className={"icInput"}
            placeholder={"Please enter you name"}
            onChange={txt => this.onNameChange(txt)}
            value={name}
          />

          <FormattedMessage
            id="profile.details.email"
            defaultMessage="Email"
            description="email"
          />
          <TextInput
            type={"email"}
            className={"icInput"}
            placeholder={"Please enter you email"}
            onChange={txt => this.onEmailChange(txt)}
            value={email}
          />
          <FormattedMessage
            id="profile.details.occupation"
            defaultMessage="Occupation"
            description="Occupation"
          />
          <WhiteSpace />
          <Select
            placeholder={"Please select your occupation"}
            options={occupationList}
            onChange={this.handleChange}
            value={selectedOption}
          />
          {occupation === 999 ? (
            <TextInput
              type={"default"}
              className={"icInput"}
              placeholder={"Please enter you occupation"}
              onChange={txt => this.onOtherChange(txt)}
              value={other && other.value ? other.value : null}
              error={other && other.error ? other.error : null}
            />
          ) : null}
          <WhiteSpace />
          <StyledButton
            activeStyle={{ backgroundColor: Theme.ActivePrimary }}
            onClick={() => this.onSubmit()}
          >
            <FormattedMessage
              id="profile.details.submit"
              defaultMessage="Submit"
              description="Submit"
            />
          </StyledButton>
        </StyledContent>
      </StyledContainer>
    );
  }
}

ProfileDetailsPage.propTypes = {
  intl: PropTypes.object,
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  getOccupation: PropTypes.func.isRequired,
  OccupationData: PropTypes.object.isRequired,
  updateProfileBasic: PropTypes.func.isRequired,
  getProfileDetails: PropTypes.object,
  profileDetailsBasicLoading: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    OccupationData: selectors.getOccupationData(state),
    getProfileDetails: selectors.getProfileDetails(state),
    profileDetailsBasicLoading: selectors.getUpdateProfileBasicLoading(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getOccupation: () => dispatch(commonAction.getOccupationRequest()),
    updateProfileBasic: data =>
      dispatch(profileAction.updateProfileBasicRequest(data))
  };
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProfileDetailsPage)
);



// WEBPACK FOOTER //
// ./src/containers/ProfileDetailsPage/index.js